var React = require('react');

function IonAndroidClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M405 136.8L375.2 107 256 226.2 136.8 107 107 136.8 226.2 256 107 375.2l29.8 29.8L256 285.8 375.2 405l29.8-29.8L285.8 256z"}));
}

IonAndroidClose.displayName = "IonAndroidClose";

IonAndroidClose.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = IonAndroidClose;

IonAndroidClose.default = IonAndroidClose;
